import { AuthenticationAPI, AuthenticationLegacyAPI } from '../helpers/APIS/CommonApisSchema';
import { DataKey } from '../Store/callAPI/allAPIs';
import { callAPIStoreKey } from '../Store/callAPI/reducer';
import tuftsLogo from '../assets/images/Tufts.svg';
import GGHLogo from '../assets/images/gghLogo.png';

export const carePlanContent = {
    isSuccess: true,
    errorMessage: null,
    warnings: null,
    data: {
        EN: {
            header: [
                {
                    content:
                        'GroundGame.Health works with health plans and local community groups all over the country to help plan members get the support they need to maintain their health and well-being.',
                    style: {
                        backgroundColor: '#ECFFFE',
                        color: '#25676D'
                    }
                },
                {
                    content:
                        'Below are the needs we identified during our call. Your care plan may be updated periodically with additional resources in your area. To ensure that you have the most up-to-date information, please check the link to your care plan that was shared with you via text message or email.'
                }
            ],
            desclaimer: [
                {
                    content:
                        'The information provided under this care plan is intended only for informational purposes for your general knowledge and is not a substitute for medical advice or treatment, or for the care that patients receive from their physicians. This care plan and its health-related information and resources are not intended, and must not be taken, to be the rendering of medical, nursing, or professional health care advice or services, diagnosis, or the practice of medicine, nursing, or professional health care, in any jurisdiction.',
                    header: 'Disclaimer',
                    style: {
                        fontStyle: 'italic'
                    }
                },
                {
                    content:
                        'Always seek the advice of your physician before beginning any new treatment or if you have any questions regarding a medical condition. You should not disregard medical advice from a qualified medical professional because of information you received from this program. You should seek prompt medical care for any specific health issues and consult your physician before starting a new fitness regimen.',
                    style: {
                        fontStyle: 'italic'
                    }
                },
                {
                    content: 'Health benefits and health insurance plans contain exclusions and limitations.',
                    style: {
                        fontStyle: 'italic'
                    }
                },
                {
                    content: 'IF YOU BELIEVE YOU ARE EXPERIENCING A MEDICAL EMERGENCY, CONTACT YOUR DOCTOR OR CALL 911 IMMEDIATELY.',
                    style: {
                        fontStyle: 'italic'
                    }
                },
                {
                    content:
                        'This disclaimer concerning medical advice shall apply to all information and materials provided by GroundGame.Health Inc. or its subcontractors.',
                    style: {
                        fontStyle: 'italic'
                    }
                },
                {
                    content:
                        'Thank you for participating in our program. This program is included for you as a benefit from your insurance provider and has no additional cost to you. You will receive an EOB (Explanation of Benefits) for services provided by PCHP, LLC (doing business as GroundGame.Health).',
                    header: 'Attention',
                    style: {
                        fontStyle: 'italic'
                    }
                }
            ],
            topBanner: [
                {
                    content:
                        'GroundGame.Health helps connect people with local programs and services to improve their overall health and well-being. Below is your care plan that lists the needs that we identified on the call. Please note that this plan may be updated with additional resources in your area. You can also download the care plan as a PDF for your convenience.'
                }
            ],
            noContent: [
                {
                    content: 'A resource is not yet available for this need.'
                },
                {
                    content: 'As soon as your care plan is updated, we will notify you using your preferred communication method.'
                }
            ],
            noData: [
                {
                    content: 'No local agencies provided'
                }
            ],
            suggestedText: 'Below are the suggested Local Agencies',
            topBannerCall: 'Hi'
        },
        ES: {
            header: [
                {
                    content:
                        'GroundGame.Health trabaja con planes de salud y grupos comunitarios locales de todo el país para ayudar a las personas a obtener el apoyo que necesitan para cuidar su salud y bienestar.',
                    style: {
                        backgroundColor: '#ECFFFE',
                        color: '#25676D'
                    }
                },
                {
                    content:
                        'A continuación, encontrará las áreas de apoyo que identificamos durante nuestra llamada. Su plan podría actualizarse si se encuentran recursos adicionales en su área. Para asegurar que tiene la información más actualizada, por favor revise el enlace de su plan de apoyo que le enviamos por mensaje de texto o correo electrónico.'
                }
            ],
            desclaimer: [
                {
                    content:
                        'La información proporcionada en este plan de apoyo está destinada únicamente a fines informativos para su conocimiento general y no sustituye al consejo o tratamiento médico, ni a la atención que los pacientes reciben de sus médicos. Este plan de apoyo y su información y recursos relacionados con la salud no pretenden, ni deben considerarse como la prestación de asesoramiento o servicios médicos, de enfermería o de atención médica profesional, diagnóstico o la práctica de la medicina, la enfermería o la atención médica profesional en ninguna jurisdicción.',
                    header: 'Disclaimer',
                    style: {
                        fontStyle: 'italic'
                    }
                },
                {
                    content:
                        'Consulte siempre a su médico antes de iniciar un nuevo tratamiento o si tiene alguna duda sobre una condición médica. No debe ignorar el consejo médico de un profesional médico cualificado debido a la información que ha recibido de este programa. Debe buscar atención médica inmediata para cualquier problema de salud específico y consultar a su médico antes de comenzar un nuevo régimen de ejercicios. Los beneficios de salud y los planes de seguro médico contienen exclusiones y limitaciones. SI USTED CREE QUE ESTÁ EXPERIMENTANDO UNA EMERGENCIA MÉDICA, PÓNGASE EN CONTACTO CON A SU DOCTOR O LLAME 911 INMEDIATAMENTE.',
                    style: {
                        fontStyle: 'italic'
                    }
                },
                {
                    content:
                        'Este aviso legal referente a consejo médico se aplicará a toda la información y materiales proporcionados por GroundGame.Health Inc. o sus subcontratistas.',
                    style: {
                        fontStyle: 'italic'
                    }
                },
                {
                    content:
                        'Gracias por participar en nuestro programa. Este programa es parte de los beneficios de su seguro de salud y no tiene ningun costo adicional para Ud. Ud. recibira una explicacion de beneficios (EOB) por los servicios proporcionados por PCHP, LLC (brindando servicios como GroundGame.Health).',
                    header: 'Atención',
                    style: {
                        fontStyle: 'italic'
                    }
                }
            ],
            topBanner: [
                {
                    content:
                        'GroundGame.Health ayuda a las personas a encontrar programas y servicios para mejorar su salud y bienestar. A continuación, encontrará su plan con las áreas de apoyo que identificamos durante la llamada. Por favor tenga en cuenta que este plan podría actualizarse si se encuentran recursos adicionales en su área. También puede descargar su plan de apoyo en formato PDF para que le sea más fácil.'
                }
            ],
            noContent: [
                {
                    content: 'Aún no hay un recurso disponible para este tipo de apoyo.'
                },
                {
                    content: 'En cuanto se actualice su plan le notificaremos utilizando su método de comunicación preferido.'
                }
            ],
            noData: [
                {
                    content: 'No se proporcionan agencias locales'
                }
            ],
            suggestedText: 'A continuación se muestran las agencias locales sugeridas',
            topBannerCall: 'Hola'
        }
    },
    totalRecords: 2,
    totalPages: 1,
    recordsPerPage: 10,
    currentPage: 1
};

export const languagesList = [
    {
        label: 'English',
        value: 'EN'
    },
    { label: 'Española', value: 'ES' }
];

export const carePalnLanguage = {
    isSuccess: true,
    errorMessage: null,
    warnings: null,
    data: [
        {
            label: 'English',
            value: 'EN'
        },
        {
            value: 'ES',
            label: 'Española'
        }
    ],
    totalRecords: 2,
    totalPages: 1,
    recordsPerPage: 10,
    currentPage: 1
};

export const formSelectDefault = {
    control: (base, { isDisabled }) => ({
        ...base,
        border: '1px solid #ced4da',
        background: isDisabled && '#eff2f7'
    }),
    placeholder: (base) => ({
        ...base,
        color: '#9599ad'
    })
};

export const multiSelectScroll = (value1, error) => {
    const style = {
        control: (base, { isDisabled }) => ({
            ...base,
            maxHeight: '60px',
            overflow: 'auto',
            border: error && '1px solid #f06548',
            background: isDisabled && '#eff2f7'
        }),
        indicatorsContainer: (base) => ({
            ...base,
            alignItems: 'start'
        })
    };
    return style;
};
export const selectCustomStyles = {
    control: (base) => ({
        ...base,
        minHeight: 30
    }),
    dropdownIndicator: (base) => ({
        ...base,
        padding: 4
    }),
    valueContainer: (base) => ({
        ...base,
        padding: '0px 6px'
    })
};
function pad(n) {
    return n < 10 ? '0' + n : n;
}

export const dateInRequireFormate = (param, formate) => {
    if (param === '' || param === null || (typeof param === 'object' && !Date.parse(param))) {
        return '';
    }
    const dateObj = new Date(param);
    if (isNaN(new Date(dateObj).getTime())) return 'NA';
    const month = dateObj.getMonth() + 1;
    const day = dateObj.getDate();
    const year = dateObj.getFullYear();
    const hours = dateObj.getHours();
    const min = dateObj.getMinutes();
    const seco = dateObj.getSeconds();
    switch (formate) {
        case 'm-d-y':
            return month + '-' + day + '-' + year;
        case 'd-m-y':
            return day + '-' + month + '-' + year;
        case 'm/d/y':
            return pad(month) + '/' + pad(day) + '/' + year;
        case 'm/d/y/t':
            return pad(month) + '/' + pad(day) + '/' + year + ' ' + pad(hours) + ':' + pad(min) + ':' + pad(seco);
        case 'm/d/y/hh:mm':
            return pad(month) + '/' + pad(day) + '/' + year + ' ' + pad(hours) + ':' + pad(min);
        default:
            return year + '-' + month + '-' + day;
    }
};

// create getting token from redux store

export const getTokenFromStore = (store) => {
    return {
        token:
            store?.[callAPIStoreKey]?.[AuthenticationAPI.storeKey]?.[DataKey]?.data?.token ||
            store?.[callAPIStoreKey]?.[AuthenticationLegacyAPI.storeKey]?.[DataKey]?.data?.token,
        apiKey:
            store?.[callAPIStoreKey]?.[AuthenticationAPI.storeKey]?.[DataKey]?.data?.apiKey ||
            store?.[callAPIStoreKey]?.[AuthenticationLegacyAPI.storeKey]?.[DataKey]?.data?.apiKey
    };
};

export const tenantLogoConfig = {
    ggh: {
        src: GGHLogo,
        alt: 'ggh logo',
        // className: 'custom-logo'
        className: 'ggh-custom-logo'
    },
    // uhc: {
    //     src: GGHLogo,
    //     alt: 'ggh logo',
    //     className: 'main-logo'
    // },
    uhc: {
        src: GGHLogo,
        alt: 'ggh logo',
        className: 'custom-logo'
    },
    tufts: {
        src: tuftsLogo,
        alt: 'tuft logo',
        className: 'tuft-custom-logo py-1'
    },
    authggh: {
        src: GGHLogo,
        alt: 'ggh logo',
        className: 'main-logo'
    },
    authuhc: {
        src: GGHLogo,
        alt: 'ggh logo',
        className: 'main-logo'
    },
    authtufts: {
        src: tuftsLogo,
        alt: 'tuft logo',
        className: 'auth-tuft-logo'
    }
};

export const getSpecificTenantLogo = (tenant, isHeightWidthFixed = false) => {
    const config = tenantLogoConfig[tenant] || tenantLogoConfig['ggh'];
    if (config?.isHeightWidthFixed || isHeightWidthFixed) {
        return <img src={config.src} alt={config.alt} height={40} width={160} />;
    }
    return <img src={config.src} alt={config.alt} className={config.className} />;
};
